const BorrowingPill = ({ borrowingType = "not set" }) => {
  return (
    <>
      <div
        data-shape="pill"
        className="relative inline-flex w-max items-center border select-none font-sans font-medium rounded-md data-[shape=pill]:rounded-full text-xs p-0.2 shadow-sm bg-transparent border-slate-800 text-slate-800"
      >
        <span className="font-sans text-current leading-none my-0.5 mx-1.5 uppercase">
          {borrowingType}
        </span>
      </div>
    </>
  );
};

export default BorrowingPill;
